module.exports = __webpack_public_path__ + "static/media/button.56576e12.png";